export const formatDate = (d) => (d ? new Date(d).toLocaleString() : '—');

export const formatVal = (v) => (v != null && v !== '' ? String(v) : '—');

export const fileName = (path) => (path ? path.split('/').pop() : null);

const CURRENCY_SYMBOLS = { GBP: '£', USD: '$', EUR: '€', CHF: 'CHF', AUD: 'A$', CAD: 'C$' };
/** Returns the symbol for a currency code for display (e.g. "£" for GBP). */
export const currencySymbol = (code) => (code && CURRENCY_SYMBOLS[code] ? CURRENCY_SYMBOLS[code] : code) || '£';
